export const messages = {
  map: { id: 'locationInputMap.map', defaultMessage: 'Kartta' },
}
